import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TranslateService} from "../../../shared/translate.service";
import {ObjectDetailService} from "../object-detail.service";

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.scss']
})
export class StatisticsComponent implements OnInit {

  @Input() statMaterializatipnCount: number = 0;

  @Input() statItemCount: number = 0;

  @Input() statLibraryCount: number = 0;

  @Input() statDigitalLibraryCount: number = 0;

  @Input() onlineVersions: boolean = false;

  @Output() clickEvent = new EventEmitter();

  constructor(private translateService: TranslateService,
              private objectDetailService: ObjectDetailService) {
  }

  ngOnInit() {
  }

  getStatistics(): string {
    let mat = this.getMatString();
    let item = this.getItemString();
    let lib = this.getLibraryString();
    let libIn = this.statDigitalLibraryCount && this.statDigitalLibraryCount > 0 ? this.translateService.translate('statistics.library.in') + ' ' + this.translateService.translate('statistics.library.this') : '';
    return mat + ' ' + item + ' ' + lib + ' ' + libIn;
  }

  getLibraries(): string {
    return this.statDigitalLibraryCount && this.statDigitalLibraryCount > 0 ?
      this.statDigitalLibraryCount + ' ' + this.translateService.translate(this.getLibraryKey('statistics.digital', this.statDigitalLibraryCount)) : '';
  }

  private getMatString(): string {
    return this.statMaterializatipnCount && this.statMaterializatipnCount > 0 ? this.statMaterializatipnCount + ' ' + this.translateService.translate(this.getStandardKey("statistics.materialization", this.statMaterializatipnCount)) : '';
  }

  private getItemString(): string {
    return this.statItemCount && this.statItemCount > 0 ? this.statItemCount + ' ' + this.translateService.translate(this.getStandardKey("statistics.item", this.statItemCount)) : '';
  }

  private getLibraryString(): string {
    return this.statLibraryCount && this.statLibraryCount > 0 ?
      this.translateService.translate('statistics.library.in') + ' ' + this.statLibraryCount + ' ' + this.translateService.translate(this.getLibraryKey("statistics.library", this.statLibraryCount)) : '';
  }

  private getStandardKey(key: string, count: number): string {
    let ending = '';
    if (count === 1) {
      ending = 'singularNominativ';
    } else if (count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20)) {
      ending = 'pluralNominativ';
    } else {
      ending = 'pluralGenitive';
    }
    return key + '.' + ending;
  }

  private getLibraryKey(key: string, count: number) {
    let ending = '';
    if (count === 1) {
      ending = 'singularNominativ';
    } else {
      ending = 'pluralNominativ';
    }
    return key + '.' + ending;
  }

  onClick() {
    this.objectDetailService.libraryClick.emit();
  }

  onOnlineVersionClick() {
    this.objectDetailService.onlineVersionClick.emit();
  }
}
